import { computed } from 'vue';
import state from '../';
import { clipping_model_editable, clipping_on } from '@features/clipping';

export const disabled = computed(() =>
    !state.loaded
    || state.editing_reference_partstudio
    || state.editing_reference_sketches
    || state.editing_reference_stl
    || state.rigid_move_manipulator
    || (
        clipping_on.value
        && !clipping_model_editable.value
    )
    || state.setting_symmetry_plane
    || state.setting_mirror_plane
    || state.selecting_tangent_perpendicular_plane
    || state.adding_vertex
    || state.currently_loading_model
    || state.offset_face_selecting_vertex
    || state.offset_face_dragging
);
